import {
  Videocam,
  Person,
  LocalOffer,
  Home,
  LocalTaxi,
  MonetizationOn,
  DirectionsWalk,
} from '@material-ui/icons';
import styled from 'styled-components';
import { textEllipsis } from '../../../../../../../common/styles/Layout';
import { ThemeColours } from '../../../../../../../common/styles/ThemeColours';
import {
  BorderRadius,
  FontSize,
  FontWeight,
  FONT_STACK,
} from '../../../../../../../common/styles/constants';

export const TagView = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono100};
  border-radius: ${BorderRadius.LARGE};
  display: inline-flex;
  flex-direction: row;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 4px 8px;
  &:hover {
    background-color: ${ThemeColours.mono200};
  }
`;

export const Value = styled.div`
  color: ${ThemeColours.primary700};
  font-size: ${FontSize.EXTRA_SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 12px;
  ${textEllipsis};
  ${FONT_STACK};
`;

export const BulkBilledIcon = styled(MonetizationOn)`
  color: ${ThemeColours.positive300};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const TelehealthIcon = styled(Videocam)`
  color: ${ThemeColours.primary400};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const TelehealthEnabledIcon = styled(Videocam)`
  color: ${ThemeColours.negative500};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const PersonIcon = styled(Person)`
  color: ${ThemeColours.warning300};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const OfferIcon = styled(LocalOffer)`
  color: ${ThemeColours.warning500};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const WalkInIcon = styled(DirectionsWalk)`
  color: ${ThemeColours.mono600};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const HomeIcon = styled(Home)`
  color: ${ThemeColours.positive500};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;

export const UberIcon = styled(LocalTaxi)`
  color: ${ThemeColours.black};
  height: 12px !important;
  margin: 0 4px 0 0;
  width: 12px !important;
`;
